export default __webpack_public_path__ + "static/giverny-parker-450x520-7921b5de3c44a8f42cccd06cd5fe6011.jpg";